var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect, _path25, _path26, _path27, _path28, _path29, _rect2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle, _path37, _rect3, _rect4, _path38, _path39, _path40, _path41, _ellipse, _circle2, _line, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _rect5, _path75, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _rect6, _rect7, _rect8, _rect9, _rect10, _line13, _line14, _line15, _line16, _line17, _rect11, _line18, _line19, _line20, _line21, _line22, _rect12, _rect13, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _rect14, _rect15, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _rect16, _path104, _rect17, _rect18, _path105, _path106, _circle3, _path107, _path108, _path109, _path110, _path111, _circle4, _circle5, _path112, _circle6, _path113, _path114, _path115, _rect19, _path116, _rect20, _circle7, _ellipse2, _circle8, _rect21, _rect22, _rect23, _rect24, _path117, _path118, _line23, _line24, _line25, _path119, _rect25, _ellipse3, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _mask, _rect26, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _rect27, _path136, _path137, _ellipse4, _circle9, _path138, _path139, _rect28, _rect29, _path140, _path141, _circle10, _circle11, _line26, _line27, _path142, _path143;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundLandscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 932,
    viewBox: "0 0 1440 932",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M779 275.34C779 274.236 778.105 273.34 777 273.34C775.895 273.34 775 274.236 775 275.34H779ZM839.817 275.34L839.865 277.34L841.817 277.293V275.34H839.817ZM940.226 275.34H938.226V277.34H940.226V275.34ZM961 277.34C962.105 277.34 963 276.445 963 275.34C963 274.236 962.105 273.34 961 273.34V277.34ZM775 275.34C775 276.157 775.46 276.677 775.71 276.897C775.961 277.118 776.213 277.235 776.343 277.289C776.617 277.405 776.899 277.468 777.095 277.506C777.52 277.588 778.071 277.649 778.682 277.697C779.927 277.796 781.691 277.866 783.826 277.914C788.109 278.009 794.022 278.019 800.57 277.975C813.672 277.888 829.389 277.589 839.865 277.34L839.77 273.341C829.306 273.59 813.614 273.888 800.543 273.975C794.004 274.019 788.139 274.009 783.915 273.915C781.797 273.868 780.126 273.8 778.999 273.71C778.424 273.664 778.054 273.617 777.856 273.579C777.74 273.557 777.784 273.556 777.899 273.604C777.948 273.625 778.14 273.707 778.351 273.892C778.561 274.077 779 274.561 779 275.34H775ZM841.817 275.34C841.817 259.582 846.615 250.367 852.806 245.049C859.057 239.68 867.055 238 873.946 238V234C866.493 234 857.427 235.806 850.199 242.015C842.912 248.275 837.817 258.729 837.817 275.34H841.817ZM873.946 238C884.496 238 893.376 244.147 899.71 252.101C906.077 260.096 909.538 269.505 909.538 275.34H913.538C913.538 268.335 909.579 258.074 902.839 249.609C896.065 241.103 886.149 234 873.946 234V238ZM913.538 275.34C913.538 273.225 914.689 271.692 916.895 270.619C919.178 269.509 922.394 269.03 925.777 269.207C929.147 269.383 932.439 270.198 934.819 271.438C937.292 272.727 938.226 274.145 938.226 275.34H942.226C942.226 271.865 939.574 269.406 936.668 267.891C933.668 266.328 929.788 265.412 925.986 265.213C922.198 265.015 918.241 265.516 915.145 267.022C911.973 268.565 909.538 271.285 909.538 275.34H913.538ZM940.226 277.34H961V273.34H940.226V277.34Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1131 202.34C1131 201.236 1130.1 200.34 1129 200.34C1127.9 200.34 1127 201.236 1127 202.34H1131ZM1191.82 202.34L1191.86 204.34L1193.82 204.293V202.34H1191.82ZM1292.23 202.34H1290.23V204.34H1292.23V202.34ZM1313 204.34C1314.1 204.34 1315 203.445 1315 202.34C1315 201.236 1314.1 200.34 1313 200.34V204.34ZM1127 202.34C1127 203.157 1127.46 203.677 1127.71 203.897C1127.96 204.118 1128.21 204.235 1128.34 204.289C1128.62 204.405 1128.9 204.468 1129.09 204.506C1129.52 204.588 1130.07 204.649 1130.68 204.697C1131.93 204.796 1133.69 204.866 1135.83 204.914C1140.11 205.009 1146.02 205.019 1152.57 204.975C1165.67 204.888 1181.39 204.589 1191.86 204.34L1191.77 200.341C1181.31 200.59 1165.61 200.888 1152.54 200.975C1146 201.019 1140.14 201.009 1135.92 200.915C1133.8 200.868 1132.13 200.8 1131 200.71C1130.42 200.664 1130.05 200.617 1129.86 200.579C1129.74 200.557 1129.78 200.556 1129.9 200.604C1129.95 200.625 1130.14 200.707 1130.35 200.892C1130.56 201.077 1131 201.561 1131 202.34H1127ZM1193.82 202.34C1193.82 186.582 1198.62 177.367 1204.81 172.049C1211.06 166.68 1219.06 165 1225.95 165V161C1218.49 161 1209.43 162.806 1202.2 169.015C1194.91 175.275 1189.82 185.729 1189.82 202.34H1193.82ZM1225.95 165C1236.5 165 1245.38 171.147 1251.71 179.101C1258.08 187.096 1261.54 196.505 1261.54 202.34H1265.54C1265.54 195.335 1261.58 185.074 1254.84 176.609C1248.07 168.103 1238.15 161 1225.95 161V165ZM1265.54 202.34C1265.54 200.225 1266.69 198.692 1268.89 197.619C1271.18 196.509 1274.39 196.03 1277.78 196.207C1281.15 196.383 1284.44 197.198 1286.82 198.438C1289.29 199.727 1290.23 201.145 1290.23 202.34H1294.23C1294.23 198.865 1291.57 196.406 1288.67 194.891C1285.67 193.328 1281.79 192.412 1277.99 192.213C1274.2 192.015 1270.24 192.516 1267.15 194.022C1263.97 195.565 1261.54 198.285 1261.54 202.34H1265.54ZM1292.23 204.34H1313V200.34H1292.23V204.34Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M626 282.143C626 264.643 655.5 266.643 655.5 284.38C655.5 272.143 670.5 274.643 670.5 284.38",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1012 393.143C1012 375.643 1041.5 377.643 1041.5 395.38C1041.5 383.143 1056.5 385.643 1056.5 395.38",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94 346H142",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1173 333H1221",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1307 366.143C1307 348.643 1336.5 350.643 1336.5 368.38C1336.5 356.143 1351.5 358.643 1351.5 368.38",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115 429.143C115 411.643 144.5 413.643 144.5 431.38C144.5 419.143 159.5 421.643 159.5 431.38",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M402 136.143C402 118.643 431.5 120.643 431.5 138.38C431.5 126.143 446.5 128.643 446.5 138.38",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M729 85H777",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M515 2H563",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M262 85H310",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.5 83.1431C1012.5 65.6431 1042 67.6431 1042 85.3795C1042 73.1431 1057 75.6431 1057 85.3795",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1329 82.6431H1377",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M795 21.1431C795 3.6431 824.5 5.6431 824.5 23.3795C824.5 11.1431 839.5 13.6431 839.5 23.3795",
    stroke: "#F4F4F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775 461H866V735H1012V655H1114V975H1012H866H863H775V979H615H535V986H261L261 975H158H80H78H0V632H78V575H158V666L261 666H307V701H489V666H535V522H615V636H775V461Z",
    fill: "#F4F4F4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1505 482H1596V602H1641V643H1823V602H1869L2017 602V676H2119V996H2016V979H1869H1596V996H1505H1345H1265H1163H1084H1083H1004V654H1083V597H1163V688H1265V539H1345V654H1505V482Z",
    fill: "#F4F4F4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M388 639.4C582.265 689.653 745.597 694.533 1008 632",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M387 640.058C522.588 720.273 880.211 715.588 999 636",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M999.113 585.579C999.113 585.579 999.113 585.579 999.113 585.578C999.114 584.445 999.703 583.475 1001.07 582.673C1002.5 581.841 1004.56 581.35 1006.76 581.35C1008.97 581.35 1011.03 581.841 1012.45 582.673C1013.82 583.475 1014.41 584.445 1014.41 585.577C1014.41 585.578 1014.41 585.579 1014.41 585.579L1014.01 873.65H999.333L999.113 585.579Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M990.763 714C990.763 722.284 997.479 729 1005.76 729C1014.05 729 1020.76 722.284 1020.76 714H990.763Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M990.763 714V711.65H988.413V714H990.763ZM1020.76 714H1023.11V711.65H1020.76V714ZM1005.76 726.65C998.777 726.65 993.113 720.986 993.113 714H988.413C988.413 723.582 996.181 731.35 1005.76 731.35V726.65ZM1018.41 714C1018.41 720.986 1012.75 726.65 1005.76 726.65V731.35C1015.35 731.35 1023.11 723.582 1023.11 714H1018.41ZM1020.76 711.65H990.763V716.35H1020.76V711.65Z",
    fill: "#4D4D4D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1022.33 712C1023.09 712 1023.7 711.341 1023.48 710.61C1022 705.713 1014.85 702 1006.26 702C997.674 702 990.53 705.713 989.046 710.61C988.825 711.341 989.436 712 990.2 712H1022.33Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M989.046 710.61L986.797 709.929L989.046 710.61ZM1006.26 704.35C1010.24 704.35 1013.8 705.212 1016.48 706.566C1019.2 707.942 1020.74 709.681 1021.23 711.291L1025.73 709.929C1024.73 706.642 1021.97 704.076 1018.6 702.372C1015.18 700.645 1010.88 699.65 1006.26 699.65V704.35ZM991.295 711.291C991.783 709.681 993.329 707.942 996.051 706.566C998.727 705.212 1002.29 704.35 1006.26 704.35V699.65C1001.65 699.65 997.343 700.645 993.929 702.372C990.56 704.076 987.793 706.642 986.797 709.929L991.295 711.291ZM990.2 714.35H1022.33V709.65H990.2V714.35ZM986.797 709.929C986.01 712.527 988.253 714.35 990.2 714.35V709.65C990.488 709.65 990.799 709.773 991.033 710.045C991.293 710.346 991.437 710.823 991.295 711.291L986.797 709.929ZM1021.23 711.291C1021.09 710.823 1021.23 710.346 1021.49 710.045C1021.73 709.773 1022.04 709.65 1022.33 709.65V714.35C1024.27 714.35 1026.52 712.527 1025.73 709.929L1021.23 711.291Z",
    fill: "#4D4D4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1008.76,
    y: 628,
    width: 30,
    height: 40,
    rx: 1.31089,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M387.35 584.616C387.35 583.464 387.947 582.485 389.316 581.68C390.739 580.843 392.799 580.35 395 580.35C397.201 580.35 399.261 580.843 400.684 581.68C402.053 582.485 402.65 583.463 402.65 584.615C402.65 584.616 402.65 584.616 402.65 584.616L402.281 874.65H387.35V584.616Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379 713C379 721.284 385.94 728 394.5 728C403.06 728 410 721.284 410 713H379Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M379 713V710.65H376.65V713H379ZM410 713H412.35V710.65H410V713ZM394.5 725.65C387.164 725.65 381.35 719.914 381.35 713H376.65C376.65 722.654 384.715 730.35 394.5 730.35V725.65ZM407.65 713C407.65 719.914 401.836 725.65 394.5 725.65V730.35C404.285 730.35 412.35 722.654 412.35 713H407.65ZM410 710.65H379V715.35H410V710.65Z",
    fill: "#4D4D4D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.56 711C412.325 711 412.937 710.339 412.709 709.609C411.182 704.712 403.834 701 395 701C386.166 701 378.818 704.712 377.292 709.609C377.064 710.339 377.675 711 378.441 711H411.56Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M377.292 709.609L379.535 710.308L377.292 709.609ZM395 703.35C399.107 703.35 402.79 704.216 405.558 705.577C408.378 706.964 409.967 708.711 410.466 710.308L414.953 708.909C413.924 705.61 411.076 703.053 407.632 701.359C404.136 699.64 399.728 698.65 395 698.65V703.35ZM379.535 710.308C380.033 708.711 381.622 706.964 384.443 705.577C387.211 704.216 390.894 703.35 395 703.35V698.65C390.272 698.65 385.864 699.64 382.369 701.359C378.925 703.053 376.077 705.61 375.048 708.909L379.535 710.308ZM378.441 713.35H411.56V708.65H378.441V713.35ZM375.048 708.909C374.234 711.52 376.498 713.35 378.441 713.35V708.65C378.729 708.65 379.041 708.773 379.277 709.048C379.539 709.353 379.682 709.837 379.535 710.308L375.048 708.909ZM410.466 710.308C410.319 709.837 410.462 709.353 410.724 709.048C410.959 708.773 411.272 708.65 411.56 708.65V713.35C413.503 713.35 415.767 711.52 414.953 708.909L410.466 710.308Z",
    fill: "#4D4D4D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 627,
    width: 30,
    height: 40,
    rx: 1.31089,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M490 792H620V874H490V792Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M620 850.84V792H490V874",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M544 839H559",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M549 832H565",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M555 839V833",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M559 831V827",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M537 872V812.311C537 811.587 536.413 811 535.689 811H507.311C506.587 811 506 811.587 506 812.311V872",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 829,
    r: 5,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M490 682H620V792H490V682Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 735,
    width: 11,
    height: 51,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 736,
    width: 10,
    height: 51,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M554.5 698.35C568.34 698.35 580.805 699.462 589.752 701.234C594.246 702.124 597.73 703.157 600.035 704.236C601.194 704.778 601.928 705.275 602.34 705.673C602.749 706.069 602.65 706.173 602.65 706H607.35C607.35 704.446 606.545 703.202 605.608 702.296C604.675 701.392 603.425 700.633 602.028 699.979C599.222 698.665 595.311 697.544 590.665 696.624C581.336 694.776 568.551 693.65 554.5 693.65V698.35ZM506.35 706C506.35 706.173 506.251 706.069 506.66 705.673C507.072 705.275 507.806 704.778 508.965 704.236C511.27 703.157 514.754 702.124 519.248 701.234C528.195 699.462 540.66 698.35 554.5 698.35V693.65C540.449 693.65 527.664 694.776 518.335 696.624C513.689 697.544 509.778 698.665 506.972 699.979C505.575 700.633 504.325 701.392 503.392 702.296C502.455 703.202 501.65 704.446 501.65 706H506.35ZM506.35 715.689V706H501.65V715.689H506.35ZM603.689 714.65H505.311V719.35H603.689V714.65ZM602.65 706V715.689H607.35V706H602.65ZM603.689 719.35C605.711 719.35 607.35 717.711 607.35 715.689H602.65C602.65 715.115 603.115 714.65 603.689 714.65V719.35ZM501.65 715.689C501.65 717.711 503.289 719.35 505.311 719.35V714.65C505.885 714.65 506.35 715.115 506.35 715.689H501.65Z",
    fill: "#4D4D4D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M523 716V700",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M586 716V700",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525 722.378H523.689C522.965 722.378 522.378 722.965 522.378 723.689V725V786V787.311C522.378 788.035 522.965 788.622 523.689 788.622H525H553.378H556H558.622H586H587.311C588.035 788.622 588.622 788.035 588.622 787.311V786V725V723.689C588.622 722.965 588.035 722.378 587.311 722.378H586H558.622H556H553.378H525ZM553.378 728.933C553.378 728.209 552.791 727.622 552.067 727.622H528.933C528.209 727.622 527.622 728.209 527.622 728.933V782.067C527.622 782.791 528.209 783.378 528.933 783.378H552.067C552.791 783.378 553.378 782.791 553.378 782.067V728.933ZM559.933 727.622C559.209 727.622 558.622 728.209 558.622 728.933V782.067C558.622 782.791 559.209 783.378 559.933 783.378H582.067C582.791 783.378 583.378 782.791 583.378 782.067V728.933C583.378 728.209 582.791 727.622 582.067 727.622H559.933Z",
    fill: "#4D4D4D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.5,
    cy: 754,
    rx: 2.5,
    ry: 3,
    fill: "#4D4D4D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 563,
    cy: 754,
    r: 3,
    fill: "#4D4D4D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 490,
    y1: 769.65,
    x2: 571,
    y2: 769.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M568 767L588 842.972V871",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M601 766L619 838.947V864",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M587 871L564 793",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M576 804H606",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M579 817H609",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M584 829H614",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M586 840H616",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M586 852H616",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M585 862H616",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M490 633.311C490 632.587 490.587 632 491.311 632H618.689C619.413 632 620 632.587 620 633.311V680.689C620 681.413 619.413 682 618.689 682H491.311C490.587 682 490 681.413 490 680.689V633.311Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M589 665H605",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M594 658H609",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M600 663V659",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M605 657V652",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.659 649.25C581.19 649.25 581.502 648.654 581.201 648.217L556.579 612.562C556.058 611.807 554.943 611.807 554.421 612.562L529.427 648.757C529.283 648.965 529.432 649.25 529.686 649.25C529.859 649.25 530 649.391 530 649.564V667.689C530 668.413 530.587 669 531.311 669H578.689C579.413 669 580 668.413 580 667.689V649.909C580 649.545 580.295 649.25 580.659 649.25Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M529.427 648.757L531.361 650.092L529.427 648.757ZM556.579 612.562L558.512 611.227L556.579 612.562ZM554.421 612.562L552.488 611.227L554.421 612.562ZM554.645 613.897L579.267 649.552L583.134 646.882L558.512 611.227L554.645 613.897ZM531.361 650.092L556.355 613.897L552.488 611.227L527.493 647.421L531.361 650.092ZM532.35 667.689V649.564H527.65V667.689H532.35ZM578.689 666.65H531.311V671.35H578.689V666.65ZM577.65 649.909V667.689H582.35V649.909H577.65ZM582.35 649.909C582.35 650.843 581.593 651.6 580.659 651.6V646.9C578.997 646.9 577.65 648.247 577.65 649.909H582.35ZM578.689 671.35C580.711 671.35 582.35 669.711 582.35 667.689H577.65C577.65 667.115 578.115 666.65 578.689 666.65V671.35ZM527.65 667.689C527.65 669.711 529.289 671.35 531.311 671.35V666.65C531.885 666.65 532.35 667.115 532.35 667.689H527.65ZM529.686 651.6C528.561 651.6 527.65 650.689 527.65 649.564H532.35C532.35 648.093 531.157 646.9 529.686 646.9V651.6ZM527.493 647.421C526.273 649.189 527.538 651.6 529.686 651.6V646.9C531.327 646.9 532.293 648.742 531.361 650.092L527.493 647.421ZM579.267 649.552C578.492 648.43 579.295 646.9 580.659 646.9V651.6C583.084 651.6 584.512 648.877 583.134 646.882L579.267 649.552ZM558.512 611.227C557.057 609.119 553.943 609.119 552.488 611.227L556.355 613.897C555.942 614.496 555.058 614.496 554.645 613.897L558.512 611.227Z",
    fill: "#4D4D4D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M556 641.35C560.225 641.35 563.65 644.775 563.65 649H568.35C568.35 642.179 562.821 636.65 556 636.65V641.35ZM548.35 649C548.35 644.775 551.775 641.35 556 641.35V636.65C549.179 636.65 543.65 642.179 543.65 649H548.35ZM548.35 667.689V649H543.65V667.689H548.35ZM564.689 666.65H547.311V671.35H564.689V666.65ZM563.65 649V667.689H568.35V649H563.65ZM564.689 671.35C566.711 671.35 568.35 669.711 568.35 667.689H563.65C563.65 667.115 564.115 666.65 564.689 666.65V671.35ZM543.65 667.689C543.65 669.711 545.289 671.35 547.311 671.35V666.65C547.885 666.65 548.35 667.115 548.35 667.689H543.65Z",
    fill: "#4D4D4D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M525 658H586",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M538 658V668",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M556 658V668",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M573 658V668",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M751 762H882V872H751V762Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M882 872V762H751V872",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M751 632.311C751 631.587 751.587 631 752.311 631H880.689C881.413 631 882 631.587 882 632.311V760.689C882 761.413 881.413 762 880.689 762H752.311C751.587 762 751 761.413 751 760.689V632.311Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M762 666H781",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M768 657H787",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M776 665V659",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M780 657V650",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M851 677H869",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M857 668H874",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M863 676V670",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M869 668V661",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M817 657.35C821.225 657.35 824.65 660.775 824.65 665H829.35C829.35 658.179 823.821 652.65 817 652.65V657.35ZM809.35 665C809.35 660.775 812.775 657.35 817 657.35V652.65C810.179 652.65 804.65 658.179 804.65 665H809.35ZM809.35 683.689V665H804.65V683.689H809.35ZM825.689 682.65H808.311V687.35H825.689V682.65ZM824.65 665V683.689H829.35V665H824.65ZM825.689 687.35C827.711 687.35 829.35 685.711 829.35 683.689H824.65C824.65 683.115 825.115 682.65 825.689 682.65V687.35ZM804.65 683.689C804.65 685.711 806.289 687.35 808.311 687.35V682.65C808.885 682.65 809.35 683.115 809.35 683.689H804.65Z",
    fill: "#4D4D4D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 797,
    y: 645,
    width: 40,
    height: 40,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M815.819 602.455C816.295 601.465 817.705 601.465 818.181 602.455L837.746 643.121C838.165 643.991 837.531 645 836.565 645H797.435C796.469 645 795.835 643.991 796.254 643.121L815.819 602.455Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 799.35,
    y1: 774.65,
    x2: 835.65,
    y2: 774.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 799.35,
    y1: 785.65,
    x2: 835.65,
    y2: 785.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 799.35,
    y1: 796.65,
    x2: 835.65,
    y2: 796.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 799.35,
    y1: 807.65,
    x2: 835.65,
    y2: 807.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 799.35,
    y1: 818.65,
    x2: 835.65,
    y2: 818.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 799.35,
    y1: 829.65,
    x2: 835.65,
    y2: 829.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 799.35,
    y1: 840.65,
    x2: 835.65,
    y2: 840.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 799.35,
    y1: 861.65,
    x2: 835.65,
    y2: 861.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 799.35,
    y1: 851.65,
    x2: 835.65,
    y2: 851.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 792.35,
    y1: 759.35,
    x2: 792.35,
    y2: 865.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 840.35,
    y1: 759.35,
    x2: 840.35,
    y2: 865.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 787,
    y: 702,
    width: 30,
    height: 50,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 817,
    y: 702,
    width: 30,
    height: 50,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 797,
    y: 712,
    width: 10,
    height: 30,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 828,
    y: 712,
    width: 10,
    height: 30,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 752,
    y: 732,
    width: 51,
    height: 30,
    rx: 1.31089,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 751,
    y1: 740.65,
    x2: 802,
    y2: 740.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 762.35,
    y1: 744.35,
    x2: 762.35,
    y2: 759.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 772.35,
    y1: 744.35,
    x2: 772.35,
    y2: 759.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 782.35,
    y1: 744.35,
    x2: 782.35,
    y2: 759.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 792.35,
    y1: 744.35,
    x2: 792.35,
    y2: 759.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 831,
    y: 732,
    width: 50,
    height: 30,
    rx: 1.31089,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 832,
    y1: 740.65,
    x2: 882,
    y2: 740.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 841.35,
    y1: 744.35,
    x2: 841.35,
    y2: 759.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 852.35,
    y1: 744.35,
    x2: 852.35,
    y2: 759.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 862.35,
    y1: 744.35,
    x2: 862.35,
    y2: 759.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 872.35,
    y1: 744.35,
    x2: 872.35,
    y2: 759.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 853,
    y: 782,
    width: 20,
    height: 40,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 782,
    width: 20,
    height: 40,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M750.155 651C749.981 651 749.811 650.946 749.668 650.846L686.755 606.532C686.302 606.213 685.698 606.213 685.245 606.532L622.332 650.846C622.189 650.946 622.019 651 621.845 651C621.378 651 621 651.378 621 651.845V750.689C621 751.413 621.587 752 622.311 752H749.689C750.413 752 751 751.413 751 750.689V651.845C751 651.378 750.622 651 750.155 651Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M622.332 650.846L623.685 652.767L622.332 650.846ZM749.668 650.846L751.021 648.924L749.668 650.846ZM686.755 606.532L688.108 604.61L686.755 606.532ZM685.245 606.532L683.892 604.61L685.245 606.532ZM685.402 608.453L748.315 652.767L751.021 648.924L688.108 604.61L685.402 608.453ZM623.685 652.767L686.598 608.453L683.892 604.61L620.979 648.924L623.685 652.767ZM623.35 750.689V651.845H618.65V750.689H623.35ZM749.689 749.65H622.311V754.35H749.689V749.65ZM748.65 651.845V750.689H753.35V651.845H748.65ZM753.35 651.845C753.35 650.08 751.919 648.65 750.155 648.65V653.35C749.324 653.35 748.65 652.676 748.65 651.845H753.35ZM749.689 754.35C751.711 754.35 753.35 752.711 753.35 750.689H748.65C748.65 750.115 749.115 749.65 749.689 749.65V754.35ZM618.65 750.689C618.65 752.711 620.289 754.35 622.311 754.35V749.65C622.885 749.65 623.35 750.115 623.35 750.689H618.65ZM621.845 648.65C620.081 648.65 618.65 650.08 618.65 651.845H623.35C623.35 652.676 622.676 653.35 621.845 653.35V648.65ZM620.979 648.924C621.232 648.746 621.535 648.65 621.845 648.65V653.35C622.504 653.35 623.146 653.146 623.685 652.767L620.979 648.924ZM748.315 652.767C748.854 653.146 749.496 653.35 750.155 653.35V648.65C750.465 648.65 750.768 648.746 751.021 648.924L748.315 652.767ZM688.108 604.61C686.844 603.72 685.156 603.72 683.892 604.61L686.598 608.453C686.24 608.706 685.76 608.706 685.402 608.453L688.108 604.61Z",
    fill: "#4D4D4D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M621 752H751L750.375 873H621.625L621 752Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M751 872V752H621V872",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M635 848H654",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M640 839H659",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M647 847V840",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M652 838V832",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M715 789H733",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M720 781H739",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M728 789V782",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M732 780V774",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M710 679H729",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M716 670H733",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M722 678V672",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M728 670V663",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 710,
    width: 10,
    height: 10,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 701,
    width: 30,
    height: 51,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M682 744V864",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M667.409 760C662.446 764.979 655 767.395 655 783.65C655 802.321 689.746 810.412 704.637 825.349C719.529 840.286 719.778 846.93 718.537 860",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M674 762H694M674 762H694",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M665 772H686M665 772H686",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M661 782H681M661 782H681",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M664 792H684M664 792H684",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M690 863H710M690 863H710",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M692 853H712M692 853H712",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M694 843H709M694 843H709",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M690 834H706M690 834H706",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M688 826H698M688 826H698",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M671 801H681M671 801H681",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 628,
    width: 30,
    height: 30,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M699.81 690.609L697.49 690.981L699.81 690.609ZM671.433 694.35H698.567V689.65H671.433V694.35ZM685 680.35C691.298 680.35 696.525 684.955 697.49 690.981L702.131 690.237C700.806 681.968 693.643 675.65 685 675.65V680.35ZM672.51 690.981C673.475 684.955 678.702 680.35 685 680.35V675.65C676.357 675.65 669.194 681.968 667.869 690.237L672.51 690.981ZM698.567 694.35C700.616 694.35 702.503 692.563 702.131 690.237L697.49 690.981C697.357 690.152 698.034 689.65 698.567 689.65V694.35ZM671.433 689.65C671.966 689.65 672.643 690.152 672.51 690.981L667.869 690.237C667.497 692.563 669.384 694.35 671.433 694.35V689.65Z",
    fill: "#4D4D4D"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 635,
    y: 701,
    width: 20,
    height: 31,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 717,
    y: 701,
    width: 20,
    height: 31,
    rx: 1.31089,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M944 832C944 826.477 939.523 822 934 822C928.477 822 924 826.477 924 832V874H944V832Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M924 874H921.65V876.35H924V874ZM944 874V876.35H946.35V874H944ZM934 824.35C938.225 824.35 941.65 827.775 941.65 832H946.35C946.35 825.179 940.821 819.65 934 819.65V824.35ZM926.35 832C926.35 827.775 929.775 824.35 934 824.35V819.65C927.179 819.65 921.65 825.179 921.65 832H926.35ZM926.35 874V832H921.65V874H926.35ZM944 871.65H924V876.35H944V871.65ZM941.65 832V874H946.35V832H941.65Z",
    fill: "#4D4D4D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 934,
    cy: 848,
    r: 5,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M916 842H922.689C923.413 842 924 842.587 924 843.311V850.689C924 851.413 923.413 852 922.689 852H916H914.251C914.113 852 914 851.887 914 851.749C914 851.649 913.941 851.559 913.85 851.516C912.165 850.712 911 848.992 911 847C911 845.008 912.165 843.288 913.85 842.484C913.941 842.441 914 842.351 914 842.251C914 842.113 914.113 842 914.251 842H916Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M913.85 851.516L914.862 849.394L913.85 851.516ZM916 844.35H922.689V839.65H916V844.35ZM921.65 843.311V850.689H926.35V843.311H921.65ZM922.689 849.65H916V854.35H922.689V849.65ZM916 849.65H914.251V854.35H916V849.65ZM914.862 849.394C913.963 848.966 913.35 848.052 913.35 847H908.65C908.65 849.932 910.366 852.458 912.839 853.637L914.862 849.394ZM913.35 847C913.35 845.948 913.963 845.034 914.862 844.606L912.839 840.363C910.366 841.542 908.65 844.068 908.65 847H913.35ZM914.251 844.35H916V839.65H914.251V844.35ZM916.35 842.251C916.35 843.41 915.41 844.35 914.251 844.35V839.65C912.815 839.65 911.65 840.815 911.65 842.251H916.35ZM916.35 851.749C916.35 850.699 915.729 849.808 914.862 849.394L912.839 853.637C912.152 853.309 911.65 852.598 911.65 851.749H916.35ZM914.251 849.65C915.41 849.65 916.35 850.59 916.35 851.749H911.65C911.65 853.185 912.815 854.35 914.251 854.35V849.65ZM914.862 844.606C915.729 844.192 916.35 843.301 916.35 842.251H911.65C911.65 841.402 912.152 840.691 912.839 840.363L914.862 844.606ZM921.65 850.689C921.65 850.115 922.115 849.65 922.689 849.65V854.35C924.711 854.35 926.35 852.711 926.35 850.689H921.65ZM922.689 844.35C922.115 844.35 921.65 843.885 921.65 843.311H926.35C926.35 841.289 924.711 839.65 922.689 839.65V844.35Z",
    fill: "#4D4D4D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M954 842H945.311C944.587 842 944 842.587 944 843.311V850.689C944 851.413 944.587 852 945.311 852H954C956.761 852 959 849.761 959 847C959 844.239 956.761 842 954 842Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M954 844.35H945.311V839.65H954V844.35ZM946.35 843.311V850.689H941.65V843.311H946.35ZM945.311 849.65H954V854.35H945.311V849.65ZM954 849.65C955.464 849.65 956.65 848.464 956.65 847H961.35C961.35 851.059 958.059 854.35 954 854.35V849.65ZM956.65 847C956.65 845.536 955.464 844.35 954 844.35V839.65C958.059 839.65 961.35 842.941 961.35 847H956.65ZM946.35 850.689C946.35 850.115 945.885 849.65 945.311 849.65V854.35C943.289 854.35 941.65 852.711 941.65 850.689H946.35ZM945.311 844.35C945.885 844.35 946.35 843.885 946.35 843.311H941.65C941.65 841.289 943.289 839.65 945.311 839.65V844.35Z",
    fill: "#4D4D4D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M921 832C928.235 838.259 942.45 836.32 947 832",
    stroke: "#4D4D4D",
    strokeWidth: 4.70014,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 339,
    cy: 853,
    r: 20,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 419,
    cy: 853,
    r: 20,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M352.092 820.139L337.661 854.337C337.296 855.201 337.93 856.157 338.868 856.157L375.821 856.158M352.092 820.139L404.076 820.139M352.092 820.139L375.821 856.158M352.092 820.139L352.092 809.686M404.076 820.139L419.773 854.825M404.076 820.139L375.821 856.158M404.076 820.139L404.076 806.6C404.076 805.877 404.663 805.29 405.386 805.29L416.634 805.29",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.5,
    cy: 855.5,
    r: 7.5,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M374 857L378.529 866.265C378.749 866.715 379.206 867 379.707 867H385",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M346.814 805.841C346.431 804.975 347.066 804 348.013 804H363.799C365.161 804 365.62 805.82 364.42 806.465L351.67 813.329C350.998 813.691 350.159 813.403 349.85 812.705L346.814 805.841Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M-79 874H1519",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1375.6,
    y: 670,
    width: 9,
    height: 204,
    rx: 1.10993,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1377 696.22L1327.61 679.717C1317.08 676.75 1310.67 678.833 1308.39 680.485C1308.13 680.669 1308 680.974 1308 681.289V686.175",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 684.22,
    width: 26,
    height: 54,
    rx: 1.10993,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1308.5,
    cy: 696.72,
    r: 4.5,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1308.5,
    cy: 711.22,
    rx: 4.5,
    ry: 4,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1308.5,
    cy: 725.72,
    r: 4.5,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1075,
    y: 730,
    width: 161,
    height: 143,
    rx: 1.05921,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1083,
    y: 806,
    width: 43,
    height: 33,
    rx: 1.05921,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1185,
    y: 806,
    width: 43,
    height: 33,
    rx: 1.05921,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1139,
    y: 806,
    width: 33,
    height: 67,
    rx: 1.05921,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1149 808V871",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1161 808V871",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 822.65,
    x2: 1171,
    y2: 822.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 839.65,
    x2: 1171,
    y2: 839.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 855.65,
    x2: 1171,
    y2: 855.65,
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.39 804.185C1138.11 803.972 1136.9 804.837 1136.68 806.117C1136.47 807.397 1137.33 808.608 1138.61 808.821L1139.39 804.185ZM1172.83 804.356C1171.92 803.429 1170.43 803.413 1169.5 804.321C1168.58 805.228 1168.56 806.716 1169.47 807.644L1172.83 804.356ZM1174.8 812.467L1174.41 814.785L1174.8 812.467ZM1175.73 810.681L1177.41 809.037L1175.73 810.681ZM1138.61 808.821L1174.41 814.785L1175.19 810.149L1139.39 804.185L1138.61 808.821ZM1177.41 809.037L1172.83 804.356L1169.47 807.644L1174.05 812.325L1177.41 809.037ZM1174.41 814.785C1177.67 815.327 1179.72 811.394 1177.41 809.037L1174.05 812.325C1173.18 811.433 1173.95 809.944 1175.19 810.149L1174.41 814.785Z",
    fill: "#4D4D4D"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1083,
    y: 739,
    width: 145,
    height: 34,
    rx: 1.05921,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1105,
    cy: 820.5,
    rx: 17,
    ry: 8.5,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1204 795H1220",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1209 788H1224",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1215 795V790",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1219 788V783",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1083 864H1099",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1088 857H1104",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1094 863V858",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1098 856V851",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-189-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1186,
    y: 849,
    width: 43,
    height: 17,
    rx: 1.05921
  }))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1186,
    y: 849,
    width: 43,
    height: 17,
    rx: 1.05921,
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 9.4,
    mask: "url(#path-189-inside-1)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.53 866.38C1187.73 866.139 1188.03 866 1188.34 866H1227.16C1227.49 866 1227.81 866.155 1228.01 866.419L1231.71 871.3C1232.24 871.998 1231.74 873 1230.87 873H1184.26C1183.37 873 1182.88 871.952 1183.45 871.262L1187.53 866.38Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1190 857H1225",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1182 874V882",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1233 874V883",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1190 866V874",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1225 866V874",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1186 870H1228",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1095 757H1214",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 25,
    transform: "matrix(-1 0 0 1 282.22 860)",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.72 857C234.349 857 240.116 860.79 243.086 866.379C243.286 866.755 243.672 867 244.098 867H260.22H278.03C278.623 867 279.113 866.525 279.135 865.933C280.016 842.509 274.075 829.418 260.556 812.421C260.346 812.157 260.024 812 259.687 812H65.3301C64.7171 812 64.2202 812.497 64.2202 813.11V865.89C64.2202 866.503 64.7171 867 65.3301 867H98.4034C98.8248 867 99.2073 866.76 99.4091 866.39C102.462 860.795 108.398 857 115.22 857C122.042 857 127.978 860.795 131.031 866.39C131.233 866.76 131.616 867 132.037 867H143.11C143.723 867 144.22 866.503 144.22 865.89V861.11C144.22 860.497 144.717 860 145.33 860H196.11C196.723 860 197.22 860.497 197.22 861.11V865.89C197.22 866.503 197.717 867 198.33 867H211.343C211.769 867 212.154 866.755 212.354 866.379C215.324 860.79 221.092 857 227.72 857Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M131.031 866.39L133.094 865.264L131.031 866.39ZM99.4091 866.39L101.472 867.516L99.4091 866.39ZM260.556 812.421L262.395 810.958L260.556 812.421ZM279.135 865.933L281.483 866.021L279.135 865.933ZM243.086 866.379L241.011 867.482L243.086 866.379ZM241.011 867.482C238.421 862.608 233.421 859.35 227.72 859.35V854.65C235.276 854.65 241.811 858.973 245.161 865.276L241.011 867.482ZM260.22 869.35H244.098V864.65H260.22V869.35ZM278.03 869.35H260.22V864.65H278.03V869.35ZM262.395 810.958C269.226 819.547 274.262 827.294 277.451 835.955C280.647 844.635 281.933 854.083 281.483 866.021L276.787 865.844C277.219 854.358 275.975 845.549 273.04 837.578C270.099 829.588 265.404 822.292 258.717 813.884L262.395 810.958ZM65.3301 809.65H259.687V814.35H65.3301V809.65ZM61.8702 865.89V813.11H66.5702V865.89H61.8702ZM98.4034 869.35H65.3301V864.65H98.4034V869.35ZM115.22 859.35C109.292 859.35 104.13 862.646 101.472 867.516L97.3463 865.264C100.795 858.945 107.504 854.65 115.22 854.65V859.35ZM128.968 867.516C126.311 862.646 121.149 859.35 115.22 859.35V854.65C122.936 854.65 129.646 858.945 133.094 865.264L128.968 867.516ZM143.11 869.35H132.037V864.65H143.11V869.35ZM146.57 861.11V865.89H141.87V861.11H146.57ZM145.33 862.35C146.015 862.35 146.57 861.795 146.57 861.11H141.87C141.87 859.199 143.419 857.65 145.33 857.65V862.35ZM196.11 862.35H145.33V857.65H196.11V862.35ZM194.87 861.11C194.87 861.795 195.425 862.35 196.11 862.35V857.65C198.021 857.65 199.57 859.199 199.57 861.11H194.87ZM194.87 865.89V861.11H199.57V865.89H194.87ZM211.343 869.35H198.33V864.65H211.343V869.35ZM227.72 859.35C222.019 859.35 217.02 862.608 214.429 867.482L210.279 865.276C213.629 858.973 220.165 854.65 227.72 854.65V859.35ZM143.11 864.65C142.425 864.65 141.87 865.205 141.87 865.89H146.57C146.57 867.801 145.021 869.35 143.11 869.35V864.65ZM133.094 865.264C132.909 864.924 132.525 864.65 132.037 864.65V869.35C130.706 869.35 129.558 868.595 128.968 867.516L133.094 865.264ZM98.4034 864.65C97.915 864.65 97.5318 864.924 97.3463 865.264L101.472 867.516C100.883 868.595 99.7346 869.35 98.4034 869.35V864.65ZM66.5702 865.89C66.5702 865.205 66.015 864.65 65.3301 864.65V869.35C63.4193 869.35 61.8702 867.801 61.8702 865.89H66.5702ZM199.57 865.89C199.57 865.205 199.015 864.65 198.33 864.65V869.35C196.419 869.35 194.87 867.801 194.87 865.89H199.57ZM258.717 813.884C258.948 814.175 259.301 814.35 259.687 814.35V809.65C260.747 809.65 261.743 810.139 262.395 810.958L258.717 813.884ZM278.03 864.65C277.35 864.65 276.812 865.184 276.787 865.844L281.483 866.021C281.414 867.867 279.897 869.35 278.03 869.35V864.65ZM211.343 864.65C210.849 864.65 210.463 864.93 210.279 865.276L214.429 867.482C213.846 868.58 212.688 869.35 211.343 869.35V864.65ZM65.3301 814.35C66.015 814.35 66.5702 813.795 66.5702 813.11H61.8702C61.8702 811.199 63.4193 809.65 65.3301 809.65V814.35ZM245.161 865.276C244.977 864.93 244.591 864.65 244.098 864.65V869.35C242.752 869.35 241.595 868.58 241.011 867.482L245.161 865.276Z",
    fill: "#4D4D4D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.5,
    ry: 18,
    transform: "matrix(-1 0 0 1 227.72 875)",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 18,
    transform: "matrix(-1 0 0 1 115.22 875)",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1682 869.22H64.4399V882.78H98.9837C99.7668 884.411 100.788 885.906 102.003 887.22H63.33C61.491 887.22 60.0002 885.729 60.0002 883.89V868.11C60.0002 866.271 61.491 864.78 63.33 864.78H100.401C99.4634 866.137 98.7075 867.628 98.1682 869.22ZM130.039 864.78H144.22V869.22H132.272C131.733 867.628 130.977 866.137 130.039 864.78ZM128.437 887.22C129.652 885.906 130.673 884.411 131.456 882.78H211.935C212.696 884.411 213.689 885.906 214.871 887.22H128.437ZM213.312 864.78H197.22V869.22H211.142C211.666 867.628 212.401 866.137 213.312 864.78ZM242.128 864.78H281.11C282.949 864.78 284.44 866.271 284.44 868.11V883.89C284.44 885.729 282.949 887.22 281.11 887.22H240.57C241.751 885.906 242.744 884.411 243.505 882.78H280V869.22H244.298C243.774 867.628 243.039 866.137 242.128 864.78Z",
    fill: "#4D4D4D"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M251.829 821.285C251.627 821.102 251.361 821 251.088 821H242.33C241.717 821 241.22 821.497 241.22 822.11V850.89C241.22 851.503 241.717 852 242.33 852H266.024C266.67 852 267.18 851.449 267.121 850.807C265.877 837.193 261.1 829.647 251.829 821.285Z",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 31,
    rx: 1.10993,
    transform: "matrix(-1 0 0 1 228.22 821)",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 17,
    rx: 1.10993,
    transform: "matrix(-1 0 0 1 197.22 860)",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M100.22 828L108.431 835.367C108.859 835.751 108.876 836.416 108.468 836.821L100.22 845",
    stroke: "#4D4D4D",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2202 828L92.4312 835.367C92.8593 835.751 92.8759 836.416 92.4675 836.821L84.2202 845",
    stroke: "#4D4D4D",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    transform: "matrix(-1 0 0 1 227.72 875.5)",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    transform: "matrix(-1 0 0 1 115.72 875.5)",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 2.35,
    y1: -2.35,
    x2: 32.65,
    y2: -2.35,
    transform: "matrix(-1 0 0 1 188.22 871)",
    stroke: "#4D4D4D",
    strokeWidth: 4.7,
    strokeLinecap: "round"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    y1: -2.35,
    x2: 35,
    y2: -2.35,
    transform: "matrix(0 -1 -1 0 166.22 854)",
    stroke: "#4D4D4D",
    strokeWidth: 4.7
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M858.321 134.858C857.721 135.785 857.986 137.023 858.913 137.624C859.84 138.224 861.078 137.959 861.679 137.032L858.321 134.858ZM905 143.945L903.258 144.927L904.954 147.935L906.719 144.967L905 143.945ZM948.2 136.816C948.681 137.81 949.877 138.226 950.872 137.745C951.866 137.263 952.281 136.067 951.8 135.073L948.2 136.816ZM861.679 137.032C864.55 132.597 868.01 130.054 871.65 128.858C875.313 127.654 879.317 127.761 883.323 128.904C891.392 131.206 899.137 137.621 903.258 144.927L906.742 142.962C902.144 134.809 893.576 127.669 884.42 125.057C879.812 123.743 874.974 123.555 870.401 125.058C865.806 126.568 861.637 129.737 858.321 134.858L861.679 137.032ZM906.719 144.967C911.029 137.719 919.694 131.658 928.276 129.533C932.543 128.477 936.641 128.431 940.082 129.562C943.47 130.674 946.331 132.957 948.2 136.816L951.8 135.073C949.45 130.22 945.73 127.206 941.331 125.761C936.985 124.334 932.09 124.468 927.315 125.651C917.812 128.004 908.196 134.656 903.281 142.923L906.719 144.967Z",
    fill: "#797979"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M937.321 185.858C936.721 186.785 936.986 188.023 937.913 188.624C938.84 189.224 940.078 188.959 940.679 188.032L937.321 185.858ZM984 194.945L982.258 195.927L983.954 198.935L985.719 195.967L984 194.945ZM1027.2 187.816C1027.68 188.81 1028.88 189.226 1029.87 188.745C1030.87 188.263 1031.28 187.067 1030.8 186.073L1027.2 187.816ZM940.679 188.032C943.55 183.597 947.01 181.054 950.65 179.858C954.313 178.654 958.317 178.761 962.323 179.904C970.392 182.206 978.137 188.621 982.258 195.927L985.742 193.962C981.144 185.809 972.576 178.669 963.42 176.057C958.812 174.743 953.974 174.555 949.401 176.058C944.806 177.568 940.637 180.737 937.321 185.858L940.679 188.032ZM985.719 195.967C990.029 188.719 998.694 182.658 1007.28 180.533C1011.54 179.477 1015.64 179.431 1019.08 180.562C1022.47 181.674 1025.33 183.957 1027.2 187.816L1030.8 186.073C1028.45 181.22 1024.73 178.206 1020.33 176.761C1015.99 175.334 1011.09 175.468 1006.31 176.651C996.812 179.004 987.196 185.656 982.281 193.923L985.719 195.967Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLandscape);
export default __webpack_public_path__ + "static/media/backgroundLandscape.71a4321cfe5d7abe57dd21375ff9cb97.svg";
export { ForwardRef as ReactComponent };